

const TextInput = ({ label,id,options,onValueChange }:any) => {
    return (
        <div className="col-xxxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
            {' '}
            <div className="input-container ">
                <div className="label"> {label} </div>
   
                <input
                    id={id}
                    className="custom-keyword "
                    type="text"
                    onChange={({ target }) =>
                        onValueChange(target.id, target.value)
                    }
                />
            </div>
        </div>

        
    );
}

export default TextInput;